import React from 'react'
import { useFilterContext } from 'src/contexts/FilterContext/filter-context'

import './sort.scss'
import { SorterInternalComponent } from './SorterInternalComponent'

function Sort() {
  const { selectedFacets, sort, setSort } = useFilterContext()

  return (
    <SorterInternalComponent
      setSortProp={{
        __type: 'facets',
        setSort,
      }}
      sort={sort}
      filterByUrl
      selectedFacets={selectedFacets}
    />
  )
}

export default Sort
